import { createTheme } from '@material-ui/core/styles'
import { esES } from '@material-ui/core/locale'

const theme = createTheme(
   {
      palette: {
         primary: {
            light: '#63a4fff',
            main: '#3264DC',
            dark: '#124387',
            contrastText: '#DFEAFF'
         },
         success: {
            main: '#28a745',
            light: '#5cb85c',
            dark: '#1e7e34',
            contrastText: '#ffffff'
         },
         info: {
            main: '#007bff',
            light: '#339aff',
            dark: '#0056b3'
         },
         warning: {
            main: '#FFDD81',
            light: '#ff9800',
            dark: '#f57c00'
         },
         danger: {
            main: '#e53935'
         },
         text: {
            primary: '#43496A'
         }
      }
   },
   esES
)

export default theme
